import React, { useState, useCallback, useMemo } from "react";
import ContentEditable from 'react-contenteditable';
import { Paper } from '@material-ui/core';
import DraggableDialog from './modals/adm_rol_add'
import RolDialog from './modals/adm_rol_usr'
import { useStyles } from '../../css/muiStyle';
import { AlertCompo } from "../../js/components";
import DTable from "../../compo/DTable2";
import FlagComponent from "../../compo/flagman";
import SearchBar from "../../compo/searchBar";
import Iconn from "@mdi/react";
import { mdiLock, mdiLockOpen } from "@mdi/js";


export default function Adm_rol(props){
  const param=props.param
  const Gfunc=require('../../Gfunc')
  const librery=require('../../js/data_table_librery')

  const [search,setSearch]=useState('');
  const [,setIcon]=useState('');
  const [severity, setSeverity] =useState("info");
  const [open, setOpen] =useState(false);
  const [messageA, setMessageA] = useState('');
  const [doSearch,setDoSearch]=useState(false);
  const api = '_rol.php';
  const srv = "role";
  const classes = useStyles();
  const filter = "&search="+search;
  const [reset, setReset] = useState(false);
  const [flag, setFlag] = useState(false);
  
   //handle alerts properties
   const handleAlert=useCallback((open,severity,message)=>{
    setOpen(open)
    setSeverity(severity)
    setMessageA(message)
    setTimeout(function(){
      setOpen(false)
    }, 5000);
  },[])


  //update field
  const handleOnEdit=useCallback(async(e,row,att)=>{
    const edt1=e.target.innerHTML
    const edt=Gfunc.DeleteSpace(edt1);
    if(att==='nom' ){
      if(row.role!==edt){
        const attrib=row.role;
        const response = await librery.axiosEdit(api, row, edt, att) 
        if(response.data.err&&response.data.err!=="-1"){
          handleAlert(true,'error',response.data.err)
        }else{
        Gfunc.axiosResponse(response,()=>{ row.role=edt ;e.target.innerHTML=edt})
        }
        if(response.data.err) {e.target.innerHTML=attrib}
      }else{e.target.innerHTML=edt}
    }
    else
        if(row[att]!==edt){
          const attrib=row[att];
          const response = await librery.axiosEditD(api, row, edt, att) 
          if(response.data.err&&response.data.err!=="-1"){
            handleAlert(true,'error',response.data.err)
          }else{
          Gfunc.axiosResponse(response,()=>{row[att]=edt;e.target.innerHTML=edt})
          }
          if(response.data.err) {e.target.innerHTML=attrib}
        }else {e.target.innerHTML=edt}
  },[librery,Gfunc,handleAlert]);

  const handleLockIcon=useCallback((val)=>{
      setIcon(val);
  },[]);

  const columns =useMemo(
    () => [   
      {
          name: "NOM",
          selector:row=>row.role,
          minWidth:"150px !important",
          sortField: "role",
          sortable: true,
          cell: (row,column) => {
            return (
            <ContentEditable
            html={row.role}
            name="rol"
            data-column="item"
            className="content-editable"
            disabled={false} 
            onBlur={e => handleOnEdit(e,row,"nom")}
          />
             );
           },
      },
      {
        name: "DATE",
        selector:row=>row.datin,
        minWidth:"110px !important",
        sortField: "datin",
        sortable: true
      },
      {
        name: "UTILISATEUR",
        selector:row=>row.user,
        minWidth:"120px !important",
        sortField: "user",
        sortable: true
      },
      {
        right:true,
        cell: (row) => {
          return (
            <div className="rowGrid" id='twoIcons'>
              <RolDialog row={row} param={param} />
              <FlagComponent
                title="Désactiver"
                titleFalse="Activer"
                srv={srv}
                row={row}
                att="activ"
                setFlagman={setFlag}
                flagman={flag}
                showAlert={handleAlert}
                //the following props should be sent incase the flag is an icon, cause the flag could be a checkbox
                iconTrue={<Iconn path={mdiLockOpen} color="red" size="18px" />}
                iconFalse={<Iconn path={mdiLock} color="green" size="18px" />}
              />
            </div>
          );
         },
      },   
    ], [handleOnEdit, classes, param, flag]);


  function liveSearch(e, search) {
    //this function is used to detect if we are doing a live search or a normal search
    //if param.liveSearch is true and the characters are above 3 then the search would happen each time a character is clicked
    if (param.liveSearch && search.length > 3) {
      e.preventDefault();
      setSearch(e.target.value);
    } else {
      //else it should lunch the search after the enter key is pushed
      if (e.keyCode === 13) handleSearch();
    }
  }

  function handleSearch() {
    const s = document.getElementById("searchBar");
    setSearch(s.value); //each time we set the search value a search request is sent
  }


  return (
    <div className="content">
        <AlertCompo severity={severity} open={open} setOpen={setOpen} message={messageA} />
        <Paper className={classes.paperBody} elevation={3}>
        <div className='table-header'>
          <div className='button-flex-wrapper' label="Ajouter un role" ><DraggableDialog handleAlert={handleAlert} callback={() => { setReset(true); }} param={param} /></div>
          <div className='search'>
            {doSearch && (
              <SearchBar liveSearch={liveSearch} handleSearch={handleSearch} />
            )}
          </div>
        </div>

          <div>
          <DTable
            cellHeight={21}
            columns={columns}
            api={api}
            service="get"
            filter={filter}
            setDoSearch={(val) => setDoSearch(val)}
            reset={reset} //Optional
            setReset={setReset} //Optional
            //data={data}//optional in exception cases
            //fetch={fetch}
            fixedHeader={true}
            paginationRowsPerPageOptions={[15, 25, 50, 75, 100]} //optional
          />
        </div>
      </Paper>
    </div>    

  );
}
